export function serializeUserMention(label: string, userId: string) {
  const escaped = label.replaceAll("\\", "\\\\").replaceAll("[", "\\[").replaceAll("]", "\\]");
  return `[${escaped}](user:${encodeURIComponent(userId).replaceAll("(", "%28").replaceAll(")", "%29")})`;
}
export function collectUserMentions(text: string) {
  const matches = [];
  const pattern = /(^|\s)\[((?:\\.|[^\]\\]){1,512})\]\(user:([^\s)]{1,2000})\)(?=\s)/g;
  for (const match of text.matchAll(pattern)) {
    const start = match.index + (match[1]?.length ?? 0);
    const end = match.index + match[0].length;
    try {
      matches.push({
        type: "user" as const,
        userId: decodeURIComponent(match[3]!),
        label: match[2]!.replace(/\\(.)/g, "$1"),
        source: text.slice(start, end),
        start,
        end,
      });
    } catch {
      /* Malformed links stay editable text. */
    }
  }
  return matches;
}
